/**
 * Fragment and session construction helpers.
 */
import { emptyTacticDwell } from './model.js';
/** Small dependency-free id generator (not cryptographic; fine for fragments). */
export function makeId(prefix = 'f') {
    const rand = Math.random().toString(36).slice(2, 8);
    const t = Date.now().toString(36).slice(-4);
    return `${prefix}_${t}${rand}`;
}
export function createSession(id, sensingConsent = false) {
    return {
        id: id ?? makeId('s'),
        createdAt: Date.now(),
        tacticDwell: emptyTacticDwell(),
        seen: [],
        fed: [],
        sensingConsent,
    };
}
/** Turn an authored seed into a live fragment entering a session. */
export function fragmentFromSeed(seed, sessionId, now = Date.now()) {
    return {
        id: seed.id ?? makeId(),
        text: seed.text,
        lang: seed.lang,
        parents: [],
        generation: 0,
        tactic: seed.tactic,
        vitality: 0.6,
        seenCount: 0,
        dwellTotal: 0,
        reuseCount: 0,
        originSession: sessionId,
        carriers: [sessionId],
        mutatedBy: null,
        createdAt: now,
        vitalityUpdatedAt: now,
    };
}
/** Build a child fragment from a mutation of a parent. */
export function childFragment(parent, text, op, sessionId, now = Date.now()) {
    return {
        id: makeId(),
        text,
        lang: parent.lang,
        parents: [parent.id],
        generation: parent.generation + 1,
        tactic: parent.tactic,
        // A child starts with some of the parent's vitality — inheritance, but it
        // must earn its own roots.
        vitality: Math.min(0.7, parent.vitality * 0.8 + 0.1),
        seenCount: 0,
        dwellTotal: 0,
        reuseCount: 0,
        originSession: sessionId,
        carriers: [sessionId],
        mutatedBy: op,
        createdAt: now,
        vitalityUpdatedAt: now,
    };
}
//# sourceMappingURL=factory.js.map